import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React, { Dispatch, RefObject } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { Action, FormInputs } from "../../../reducers/workoutReducer";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  collectionTime: FormInput;
  handleErrorRefs: RefObject<(() => void)[]>;
};

const CollectionTimeInput = ({ dispatch, loading, collectionTime }: Props) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="registration-time-label">Samlingstid</InputLabel>
      <Select
        disabled={loading}
        onChange={(e) =>
          dispatch({
            type: FormInputs.collectionTime,
            payload: e.target.value,
          })
        }
        label="Samlingstid"
        labelId="registration-time-label"
        id="registrationTime"
        value={collectionTime.input}>
        <MenuItem value={0}>Ingen</MenuItem>
        <MenuItem value={5}>5min innan</MenuItem>
        <MenuItem value={10}>10min innan</MenuItem>
        <MenuItem value={15}>15min innan</MenuItem>
        <MenuItem value={30}>30min innan</MenuItem>
        <MenuItem value={45}>45min innan</MenuItem>
        <MenuItem value={60}>60min innan</MenuItem>
        <MenuItem value={90}>90min innan</MenuItem>
        <MenuItem value={120}>120min innan</MenuItem>
      </Select>
    </FormControl>
  );
};

export default CollectionTimeInput;
